import { RootPage } from '../page';
import $api from '../../api';

class ResetPwdView extends RootPage {
    constructor() {
        super();

        this.email = ko.observable();

        this.done = ko.observable(false);
    }

    submitReset() {
        this.startSubmitting();

        $api.account.resetPwd({}, { email: this.email() }, (resp) => {
            this.stopSubmitting();

            TRACK_EVENT('Users', 'Reset Password Request');

            this.done(true);
        });
    }
}

export default ResetPwdView;